module.exports = __webpack_public_path__ + "d7214c7724e787608ab2dea7ea26999f.svg";